import { Pipe, PipeTransform } from '@angular/core';
import NiboWhatsAppConnection from './models/nibo-whatsapp-connection';
import { ConnectionInfrastructureFilterConfig, ConnectionStatusFilterConfig } from './components/connections-list/connections-list.component';

@Pipe({
  standalone: false,
  name: 'infra'
})
export class InfraPipe implements PipeTransform {

  transform(value: NiboWhatsAppConnection[], arg: ConnectionInfrastructureFilterConfig[]): NiboWhatsAppConnection[] {
    const filter = arg.filter(a => a.checked);
    return value.filter(conn => {
      if (conn.connection && conn.pod)
        return true;

      return filter.some(a => a.value === 'databaseMiss' && !conn.connection || a.value === 'podMiss' && !conn.pod);
    })
  }
}
